import React, { useState, useContext, useEffect } from "react";
import { useForm } from "react-hook-form";
import { HiArrowLeft, HiTrash, HiSave } from "react-icons/hi";
import { useNavigate, useSearchParams } from "react-router-dom";
import moment from "moment";

import LogicContext from "../../Context/LogicContext";
import { packageService } from "../../services/packageService";
import { stockService } from "../../services/stockService";
import { salesService } from "../../services/sales.service";

import {
  GetPackageMasterData,
  SetPackageMasterData,
  GetPackageEditAtom,
  SetPackageEditAtom,
  GetPackageListAtom,
  SetPackageListAtom,
} from "../../store/packageStore";

import { SetStockAdjustmentList, GetStockAdjustmentList } from "../../store/stockAdjustmentAtom";

import PackageCustomerSelect from "./PackageCustomerSelect";
import PackageDeliveryUserSelect from "./PackageDeliveryUserSelect";
import PackageWarehouseSelect from "./PackageWarehouseSelect";
// import PickAddressSelect from "./PickAddressSelect"; // commented as in original

import CurrencyFormat from "react-currency-format";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";

export default function PackageAddNew() {
  const navigate = useNavigate();
  const logicContext = useContext(LogicContext);
  const myPromiseModal = createModal(GeneralModal);

  const getPackageMasterData = GetPackageMasterData();
  const setPackageMasterData = SetPackageMasterData();
  const getPackageEditAtom = GetPackageEditAtom();
  const setPackageEditAtom = SetPackageEditAtom();
  const getPackageAtomList = GetPackageListAtom();
  const setPackageAtomList = SetPackageListAtom();

  const getStockData = GetStockAdjustmentList();
  const setStockData = SetStockAdjustmentList();

  const [customer, setCustomer] = useState({});
  const [tableListData, setTableListData] = useState([]);
  const [searchParams] = useSearchParams();
  const customOption = searchParams.get("option");

  const {
    register,
    setValue,
    getValues,
    handleSubmit,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (!getPackageMasterData.driver_list?.length) {
      packageService.packageMasterData().then((res) => {
        setPackageMasterData(res.data);
      });
    }
  }, [getPackageMasterData?.driver_list?.length]);

  useEffect(() => {
    if (getPackageEditAtom?.length) {

      setTableListData(getPackageEditAtom);

      const editData = getPackageEditAtom[0];
      setCustomer(editData);
      setValue("sales_order_ref_no", editData?.sales_order_ref_no);
      setValue("customer_id", editData?.customer_id);
      setValue("warehouse_id", editData?.warehouse_id);
      setValue("Package_Remark", editData?.package_remark);
      setValue("delivery_user_id", editData?.delivery_user_id);
      setValue("package_date", moment(editData?.Package_Date).format("YYYY-MM-DD"));
      setValue("pickup_date",editData?.pickup_date ? moment(editData.pickup_date).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"));
    }

    return () => {
      setPackageEditAtom([]);
    };
  }, [getPackageEditAtom]);

  useEffect(() => {
    if (!getStockData.Warehouse?.length) {
      stockService.stockAdjustmentList().then((res) => {
        setStockData(res.data);
      });
    }
  }, [getStockData.Warehouse?.length]);

  const goBack = () => navigate(-1);

  const onCustomerSelected = (selected) => {
    setValue("customer_id", selected?.customer_id);
    setCustomer(selected);

    // Fetch and filter sales orders for this customer
    // Assuming getPackageMasterData.so_details_info has sales orders
    const filtered = getPackageMasterData.so_details_info.filter(
      (sale) => sale.customer_id === selected?.customer_id
    );

    const uniqueOrders = [...new Set(filtered.map((obj) => obj.sales_order_no))].map((no) =>
      filtered.find((obj) => obj.sales_order_no === no)
    );

    if (uniqueOrders.length) {
      // setSelectedSalesOrder(uniqueOrders); // if you need sales order select
      setCustomer(uniqueOrders[0]);
      setTableListData([]);
      logicContext.showToast("Please select a sales order", "info");
    } else {
      logicContext.showToast("No sales orders found for this customer", "warning");
    }
  };

  const onDriverSelect = (user) => {
    setValue("delivery_user_id", user?.user_id);
  };

  const onWarehouseSelect = (warehouse) => {
    setValue("warehouse_id", warehouse?.warehouse_id);
  };

  // const onPickUpAddressSelect = (option) => {
  //   setValue("warehouse_id", option?.pickup_id);
  // };

  const onSubmit = async (data) => {
    const confirmed = await myPromiseModal({
      title: "Save Package",
      body: "Would you like to save this package?",
      showInput: false,
    });

    if (confirmed?.decision) {
      let option = 13; // New
      if (getPackageEditAtom?.length) option = 14; // Edit
      if (customOption) option = customOption;

      try {
        const res = await packageService.subOrUpdatePackage({ ...data, option });
        const response = logicContext.httpResponseManager(res.data?.[0] || res.data?.result_status?.[0]);
          console.log('response ... ', response);
        if (response.message_id === 1) {
          logicContext.showToast(response.message_text || 'Stock Transfer successful!', 'success');
          sessionStorage.setItem('reloadPage', 'true');
          // navigate(-1);
        goBack();

        } else {
          logicContext.showToast(response.message_text || 'Failed to save', 'error');
        }
       
      } catch (err) {
        console.log('error  ', err);
        logicContext.showToast("Failed to save package", "error");
      }
    }
  };

  const onErrors = () => {
    logicContext.showToast("Please fill in all required fields", "error");
  };

  const confirmAndDelete = async () => {
    const confirmed = await myPromiseModal({
      title: "Delete Package",
      body: `Are you sure you want to delete package with sales order ${getPackageEditAtom?.[0]?.sales_order_ref_no}?`,
      showInput: false,
    });

    if (confirmed?.decision) {
      try {
        const res = await packageService.deletePackage(getPackageEditAtom?.[0]?.sales_order_ref_no);
        if (res?.data?.[0]?.message_id === 1) {
          logicContext.showToast(res.data[0].message_text, "success");

          // Update list
          const newList = getPackageAtomList.so_not_shipped.filter(
            (lst) => lst.sales_order_ref_no !== getPackageEditAtom[0]?.sales_order_ref_no
          );
          setPackageAtomList((prev) => ({ ...prev, so_not_shipped: newList }));

          goBack();
        }
      } catch (err) {
        logicContext.showToast("Failed to delete package", "error");
      }
    }
  };

  const calculateGrandTotal = (list) => {
    return list?.reduce((total, item) => total + item.item_sales_rate * item.item_sales_quantity, 0) || 0;
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Sticky Header */}
      <div className="sticky top-0 z-10 bg-white border-b shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center gap-4">
              <button
                onClick={goBack}
                className="p-2 rounded-lg hover:bg-gray-100 text-gray-600 hover:text-gray-900 transition-colors"
              >
                <HiArrowLeft size={20} />
              </button>
              <h1 className="text-xl font-semibold text-gray-900">
                {getPackageEditAtom?.length ? "Edit Package" : "Go Back"}
              </h1>
            </div>

            <div className="flex items-center gap-3">
              {getPackageEditAtom?.length > 0 && (
                <button
                  onClick={confirmAndDelete}
                  className="inline-flex items-center gap-2 px-4 py-2 bg-rose-600 hover:bg-rose-700 text-white rounded-lg font-medium transition-colors shadow-sm"
                >
                  <HiTrash size={18} />
                  Delete
                </button>
              )}

              <button
                onClick={goBack}
                className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>

              <button
                onClick={handleSubmit(onSubmit, onErrors)}
                className="inline-flex items-center gap-2 px-5 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg font-medium transition-colors shadow-sm"
              >
                <HiSave size={18} />
                {getPackageEditAtom?.length ? "Update" : "Save"}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <main className="flex-1 overflow-y-auto bg-gray-50">
        <div className="max-w-5xl mx-auto p-6 lg:p-8">
          <form onSubmit={handleSubmit(onSubmit, onErrors)} className="space-y-8">
            {/* Customer Section */}
            <div className="bg-white rounded-xl border shadow-sm p-6">
              <h2 className="text-lg font-semibold text-gray-800 mb-6">Customer Information</h2>

              {!getPackageEditAtom?.length && (
                <div className="space-y-2">
                  <label className="block text-sm font-medium text-gray-700">
                    Customer Name <span className="text-red-500">*</span>
                  </label>
                  <PackageCustomerSelect
                    onOptionSelect={onCustomerSelected}
                    list={getPackageMasterData.customer_info}
                  />
                  {errors.customer_id && (
                    <p className="text-sm text-red-500 mt-1">{errors.customer_id.message}</p>
                  )}
                </div>
              )}

              {customer?.customer_id && (
                <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
                  <div>
                    <dt className="text-gray-600 font-medium">Email</dt>
                    <dd className="mt-1 text-gray-900">{customer.customer_email_address}</dd>
                  </div>

                  <div>
                    <dt className="text-gray-600 font-medium">Name</dt>
                    <dd className="mt-1 text-gray-900">{customer.customer_full_name}</dd>
                  </div>

                  <div>
                    <dt className="text-gray-600 font-medium">Mobile</dt>
                    <dd className="mt-1 text-gray-900">{customer.customer_mobile_no}</dd>
                  </div>

                  <div>
                    <dt className="text-gray-600 font-medium">Order Type</dt>
                    <dd className="mt-1 text-gray-900">{customer.gift_status_name}</dd>
                  </div>
                </div>
              )}
            </div>

            {/* Recipient & Shipping (if gift) */}
            {getPackageEditAtom?.gift_status_id === 2 && (
              <div className="bg-white rounded-xl border shadow-sm p-6">
                <h2 className="text-lg font-semibold text-gray-800 mb-6">Recipient Information</h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
                  <div>
                    <dt className="text-gray-600 font-medium">Recipient Name</dt>
                    <dd className="mt-1 text-gray-900">{customer?.order_recipient_name}</dd>
                  </div>

                  <div>
                    <dt className="text-gray-600 font-medium">Email</dt>
                    <dd className="mt-1 text-gray-900">{customer?.order_recipient_email}</dd>
                  </div>

                  <div>
                    <dt className="text-gray-600 font-medium">Mobile</dt>
                    <dd className="mt-1 text-gray-900">{customer?.order_recipient_phone_number}</dd>
                  </div>

                  <div className="col-span-2">
                    <dt className="text-gray-600 font-medium">Shipping Address</dt>
                    <dd className="mt-1 text-gray-900">{customer?.order_recipient_full_shipping_address}</dd>
                  </div>
                </div>
              </div>
            )}

            {/* Package Details */}
            <div className="bg-white rounded-xl border shadow-sm p-6">
              <h2 className="text-lg font-semibold text-gray-800 mb-6">Package Details</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Package Slip #
                  </label>
                  <input
                    type="text"
                    value={getPackageEditAtom[0]?.package_slip_number || "Auto generated"}
                    className="mt-1 w-full border border-gray-300 rounded-lg px-3 py-2 bg-gray-50 text-gray-500 cursor-not-allowed"
                    readOnly
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Driver <span className="text-red-500">*</span>
                  </label>
                  <PackageDeliveryUserSelect
                    defaultVal={{
                      label: getPackageEditAtom[0]?.delivery_user_full_name,
                      value: getPackageEditAtom[0]?.delivery_user_id,
                    }}
                    list={getPackageMasterData?.driver_list}
                    onOptionSelect={onDriverSelect}
                    {...register("delivery_user_id", { required: "Driver is required" })}
                  />
                  {errors.delivery_user_id && (
                    <p className="mt-1 text-sm text-red-500">{errors.delivery_user_id.message}</p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Warehouse <span className="text-red-500">*</span>
                  </label>
                  <PackageWarehouseSelect
                    defaultVal={{
                      label: getPackageEditAtom[0]?.warehouse_name,
                      value: getPackageEditAtom[0]?.warehouse_id,
                    }}
                    list={getStockData.Warehouse}
                    onOptionSelect={onWarehouseSelect}
                    {...register("warehouse_id", { required: "Warehouse is required" })}
                  />
                  {errors.warehouse_id && (
                    <p className="mt-1 text-sm text-red-500">{errors.warehouse_id.message}</p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Package Date <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="date"
                    defaultValue={
                      getPackageEditAtom[0]?.package_date
                        ? moment(getPackageEditAtom[0].package_date).format("YYYY-MM-DD")
                        : ""
                    }
                    {...register("package_date", { required: "Package date is required" })}
                    className="mt-1 w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-indigo-500 focus:border-indigo-500"
                  />
                  {errors.package_date && (
                    <p className="mt-1 text-sm text-red-500">{errors.package_date.message}</p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Pickup Date <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="date"
                      defaultValue={
                                getPackageEditAtom[0]?.pickup_date
                                  ? moment(getPackageEditAtom[0].pickup_date).format("YYYY-MM-DD")
                                  : moment().format("YYYY-MM-DD")
                              }
                    {...register("pickup_date", { required: "Pickup date is required" })}
                    className="mt-1 w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-indigo-500 focus:border-indigo-500"
                  />
                  {errors.pickup_date && (
                    <p className="mt-1 text-sm text-red-500">{errors.pickup_date.message}</p>
                  )}
                </div>

                {/* Uncomment if needed */}
                {/* <div className="col-span-3">
                  <label className="block text-sm font-medium text-gray-700">
                    Pick Up Address <span className="text-red-500">*</span>
                  </label>
                  <PickAddressSelect
                    defaultVal={getPackageEditAtom[0]?.pickup_address}
                    list={getPackageMasterData?.pickup_info}
                    onOptionSelect={(option) => setValue("warehouse_id", option?.pickup_id)}
                    {...register("warehouse_id", { required: "Pick up address is required" })}
                  />
                  {errors.warehouse_id && (
                    <p className="mt-1 text-sm text-red-500">{errors.warehouse_id.message}</p>
                  )}
                </div> */}
              </div>
            </div>

            {/* Items Table */}
            <div className="bg-white rounded-xl border shadow-sm overflow-hidden">
              <div className="px-6 py-5 border-b bg-gray-50">
                <h3 className="text-lg font-semibold text-gray-800">
                  Package Items ({tableListData.length})
                </h3>
              </div>

              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3.5 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                        #
                      </th>
                      <th className="px-6 py-3.5 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                        Item & Description
                      </th>
                      <th className="px-6 py-3.5 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                        Qty
                      </th>
                      <th className="px-6 py-3.5 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                        Rate
                      </th>
                      <th className="px-6 py-3.5 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                        Sub Total
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-100">
                    {tableListData.map((pkg, i) => (
                      <tr key={pkg.item_id || i} className="hover:bg-indigo-50/30 transition-colors">
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                          {i + 1}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                          {pkg?.item_name}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                          <CurrencyFormat
                            value={parseFloat(pkg?.item_sales_quantity)?.toFixed(2)}
                            displayType="text"
                            thousandSeparator={true}
                          />
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                          <CurrencyFormat
                            value={parseFloat(pkg?.item_sales_rate)?.toFixed(2)}
                            displayType="text"
                            thousandSeparator={true}
                          />
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                          <CurrencyFormat
                            value={formatCustomNumber(pkg?.total_amount)}
                            displayType="text"
                            thousandSeparator={true}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Grand Total */}
              <div className="px-6 py-4 border-t bg-gray-50 flex justify-end items-center">
                <div className="text-lg font-semibold text-gray-900">
                  Grand Total: <span className="text-indigo-700">
                    ₦<CurrencyFormat
                      value={calculateGrandTotal(tableListData)}
                      displayType="text"
                      thousandSeparator={true}
                    />
                  </span>
                </div>
              </div>
            </div>

            {/* Internal Notes */}
            <div className="bg-white rounded-xl border shadow-sm p-6">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Internal Notes
              </label>
              <textarea
                rows="4"
                {...register("Package_Remark")}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-indigo-500 focus:border-indigo-500 resize-y"
              ></textarea>
            </div>

            {/* Action Buttons - already in header, but can duplicate if needed */}
             <div className="mt-4">
            <label className=" text-sm ">Internal Notes</label>
            <textarea
              {...register('Package_Remark')}
              rows="3"
              className="w-full border border-gray-300 rounded-md shadow-sm p-2"
            ></textarea>
          </div>

          <div className="flex justify-end mt-4">
            {getPackageEditAtom?.length > 0 && (
              <button onClick={() => confirmAndDelete()} type="button" className="bg-red-200 text-gray-700 py-2 px-4 rounded-md mr-2">
                Delete
              </button>
            )}

            <button onClick={() => navigate(-1)} type="button" className="bg-gray-200 text-gray-700 py-2 px-4 rounded-md mr-2">
              Cancel
            </button>
            <button className="bg-blue-600 text-white py-2 px-4 rounded-md">
              {getPackageEditAtom[0]?.sales_order_no ? 'Update' : 'Save'}
            </button>
          </div>
          </form>
        </div>
      </main>
    </div>
  );
}